import { Loader2 } from "lucide-react";
import { ScrollArea } from "@/components/ui/scroll-area";
import { StoreFilterRow } from "./store-filter-row";
import { PanelStore } from "./types";

interface StoreFilterListProps {
  stores: PanelStore[];
  isLoading: boolean;
  isSelected: (code: number) => boolean;
  onToggle: (code: number) => void;
  emptyLabel: string;
  loadingLabel: string;
}

/** Lista de lojas com estados de loading, vazio e seleção. */
export function StoreFilterList({
  stores,
  isLoading,
  isSelected,
  onToggle,
  emptyLabel,
  loadingLabel,
}: StoreFilterListProps) {
  if (isLoading) {
    return (
      <div className="flex items-center justify-center py-6">
        <Loader2 className="h-5 w-5 animate-spin text-muted-foreground" />
        <span className="ml-2 text-sm text-muted-foreground">{loadingLabel}</span>
      </div>
    );
  }

  if (stores.length === 0) {
    return (
      <div className="py-6 text-center text-sm text-muted-foreground">{emptyLabel}</div>
    );
  }

  return (
    <ScrollArea className="h-[220px] rounded-md border">
      <div className="space-y-0.5 p-1.5">
        {stores.map(store => (
          <StoreFilterRow
            key={store.code}
            store={store}
            selected={isSelected(store.code)}
            onToggle={() => onToggle(store.code)}
          />
        ))}
      </div>
    </ScrollArea>
  );
}
